export default "__VITE_ASSET__wDz20hqw__"